import { dateTimeHelpers } from '@approvalmax/utils';
import { useCallback, useEffect, useState } from 'react';

import { getTimeoutFromStorage, removeTimeoutFromStorage, setTimeoutToStorage } from './useResendTimeout.helpers';

export const useResendTimeout = (resendTimeoutStorageKey: string, resendTimeoutSec: number) => {
    const [resendTimeSec, setResendTimeSec] = useState(() => getTimeoutFromStorage(resendTimeoutStorageKey) ?? 0);
    const [isTimerActive, setIsTimerActive] = useState(resendTimeSec > 0);

    useEffect(() => {
        let intervalId: ReturnType<typeof setInterval> | null = null;

        if (isTimerActive) {
            intervalId = setInterval(() => {
                setResendTimeSec((prevTimer) => {
                    if (prevTimer <= 1) {
                        setIsTimerActive(false);

                        removeTimeoutFromStorage(resendTimeoutStorageKey);

                        return 0;
                    }

                    const newValue = prevTimer - 1;

                    setTimeoutToStorage(resendTimeoutStorageKey, newValue);

                    return newValue;
                });
            }, 1000);
        }

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [isTimerActive, resendTimeoutStorageKey]);

    const startTimer = useCallback(() => {
        setResendTimeSec(resendTimeoutSec);
        setTimeoutToStorage(resendTimeoutStorageKey, resendTimeoutSec);
        setIsTimerActive(true);
    }, [resendTimeoutSec, resendTimeoutStorageKey]);

    return {
        startTimer,
        isTimerActive,
        resendTimeSec,
        formattedResendTime: dateTimeHelpers.formatTime(resendTimeSec * 1000),
    };
};
